// src/components/BookingPage/CustomerForm.js

import React from 'react';
import { Typography, Box, Grid, TextField } from '@mui/material';

export default function CustomerForm({
  customerName,
  setCustomerName,
  customerEmail,
  setCustomerEmail,
  customerPhoneNumber,
  setCustomerPhoneNumber,
}) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Ihre Angaben
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Ihr Name"
            variant="outlined"
            fullWidth
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Ihre E-Mail"
            variant="outlined"
            type="email"
            fullWidth
            value={customerEmail}
            onChange={(e) => setCustomerEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Ihre Telefonnummer"
            variant="outlined"
            type="tel"
            fullWidth
            value={customerPhoneNumber}
            onChange={(e) => {
              let phoneNumber = e.target.value.trim();
              if (phoneNumber.startsWith('0')) {
                phoneNumber = '+49' + phoneNumber.slice(1);
              }
              setCustomerPhoneNumber(phoneNumber);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
